module.exports = __webpack_public_path__ + "img/21.1a776549.png";